import { i18n as i18nGlobal, I18n, Messages } from '@lingui/core'

import { promiseAllSettled } from '~logic/helpers/fallbacks/promiseAllSettled'

export const i18n = i18nGlobal

export const activateLinguiLocale = async (
  locale: string,
  catalogs: RoA<string>,
  i18n: I18n = i18nGlobal,
) => {
  await promiseAllSettled(
    catalogs.map(async (catalog) => {
      const messages = await loadLinguiLocale(locale, catalog)
      i18n.load(locale, messages)
    }),
  )
  i18n.activate(locale)
}

const loadLinguiLocale = async (locale: string, catalog: string): Promise<Messages> => {
  const getMessages = (data: any) => data.messages
  if (process.env.NODE_ENV === 'development') {
    return import(
      /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
      `~translations/${locale}/${catalog}.po`
    ).then(getMessages)
  }

  return import(
    /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
    `~translations/${locale}/${catalog}.js`
  ).then(getMessages)
}
